export const contentAreaClass =
  'layout-content-area .xl:width(1600px) .lg:width(1210px) margin(0/auto)';

export default function ContentArea(props: { children: React.ReactNode }) {
  const { children } = props;
  return <div className={contentAreaClass}>{children}</div>;
}
